import React from "react";
import { Storage } from "aws-amplify";
import {
  Row,
  Col,
  Form,
  Upload,
  Button,
  Icon,
  Popconfirm,
  message
} from "antd";
import _ from "lodash";
import async from "async";

const FormItem = Form.Item;
const Dragger = Upload.Dragger;

class FileDownload extends React.Component {
  onDownload = () => {
    const {
      s3object: { key, bucket, region }
    } = this.props;
    Storage.get(key, {
      level: "public",
      bucket: bucket,
      region: region
    }).then(result => {
      window.open(result, "_blank");
    });
  };

  render() {
    const { children } = this.props;
    return (
      <Button
        type="primary"
        onClick={this.onDownload}
        style={{ marginBottom: 12 }}
      >
        {children}
      </Button>
    );
  }
}

class FileField extends React.Component {
  state = {
    fileList: [],
    uploading: false
  };

  handleRemoveObject = objectKey => {
    const { name, value, onChange, user } = this.props;
    const storageOpts = {
      bucket: `as-${name.toLowerCase()}`,
      region: "us-east-1"
    };
    Storage.remove(objectKey, { ...storageOpts, level: "private" })
      .then(() => {
        const currValue = _.map(value, item => ({
          key: item.key,
          bucket: item.bucket,
          region: item.region,
          identityId: item.identityId || user.id
        }));
        const newValue = _.reject(currValue, ["key", objectKey]);
        onChange(newValue);
        message.success("Archivo eliminado correctamente!");
      })
      .catch(err => {
        message.error(err);
      });
  };

  handleUpload = () => {
    const { name, value, onChange, user } = this.props;
    const { fileList } = this.state;

    const storageOpts = {
      bucket: `as-${name.toLowerCase()}`,
      region: "us-east-1"
    };

    this.setState({ uploading: true });

    async.map(
      fileList,
      (file, callback) => {
        console.log("Processing file " + file);

        Storage.put(file.name, file, {
          ...storageOpts,
          level: "private"
        })
          .then(result => {
            callback(null, { ...result, ...storageOpts, identityId: user.id });
          })
          .catch(err => {
            message.error(err);
            callback(err);
          });
      },
      (err, results) => {
        if (err) {
          message.error(err);
        } else {
          message.success("Archivos cargados correctamente!");
          if (value && value.length) {
            onChange(
              _.concat(
                results,
                _.map(value, item => ({
                  key: item.key,
                  bucket: item.bucket,
                  region: item.region,
                  identityId: item.identityId || user.id
                }))
              )
            );
          } else {
            onChange(results);
          }
        }
        this.setState({ uploading: false, fileList: [] });
      }
    );
  };

  render() {
    const {
      value,
      name,
      label,
      description,
      disabled = false,
      multiple,
      downloadFile
    } = this.props;

    const { uploading } = this.state;

    const props = {
      multiple: multiple,
      disabled: disabled,
      accept:
        "image/jpeg,image/jpg,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,.pdf",
      name: name,
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }));
        return false;
      },
      fileList: this.state.fileList
    };

    return (
      <Row gutter={32}>
        <Col md={24} xl={12}>
          <FormItem label={label} data={data => console.log(data)}>
            {downloadFile && downloadFile.key ? (
              <FileDownload s3object={downloadFile}>
                Descargar Formulario{" "}
                <Icon type="download" style={{ marginLeft: "0.5rem" }} />
              </FileDownload>
            ) : null}
            <Dragger {...props}>
              <div>
                <Icon type="plus" />
                <div>{description}</div>
              </div>
            </Dragger>
            <Button
              style={{ marginTop: 16 }}
              type="primary"
              onClick={this.handleUpload}
              disabled={this.state.fileList.length === 0}
              loading={uploading}
            >
              {uploading ? "Cargando..." : "Guardar archivos"}
            </Button>
          </FormItem>
        </Col>
        <Col md={24} xl={12}>
          <p style={{ color: "rgba(0, 0, 0, 0.85)" }}>Archivos cargados</p>
          {value && value.length
            ? _.map(value, (item, index) => (
                <div key={index}>
                  <p>
                    {item.key}{" "}
                    <Popconfirm
                      title="Estás seguro de eliminar el archivo?"
                      onConfirm={() => this.handleRemoveObject(item.key)}
                      onCancel={() => null}
                      okText="Confirmar"
                      cancelText="Cancelar"
                    >
                      <Icon
                        type="delete"
                        style={{
                          fontSize: 16,
                          color: "#f5222d",
                          cursor: "pointer"
                        }}
                      />
                    </Popconfirm>
                  </p>
                </div>
              ))
            : "No hay archivos guardados"}
        </Col>
      </Row>
    );
  }
}

export default FileField;



// WEBPACK FOOTER //
// ./src/Modules/FormFields/FileField.js